import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { childApi } from "../lib/api";
import { PitchTrainerCore } from "../components/PitchTrainerCore";
import { DEFAULT_A4 } from "../lib/tuning";

export default function PitchTrainerPage() {
  const [refA4, setRefA4] = useState(DEFAULT_A4);
  useEffect(() => {
    childApi.get("/child/tuning")
      .then((r) => setRefA4(r.data.concert_pitch || DEFAULT_A4))
      .catch(() => { /* default 440 */ });
  }, []);
  return (
    <div className="min-h-screen bg-[#FAF7EE]">
      <div className="mx-auto max-w-2xl px-4 py-6 space-y-5">
        <div className="flex items-center gap-3">
          <Link to="/play/home" data-testid="pitch-trainer-back"
            className="inline-flex items-center gap-1 text-sm font-bold text-[#0B192C] hover:text-[#7A1C2E]">
            <ChevronLeft className="w-4 h-4" aria-hidden /> Home
          </Link>
        </div>
        <div>
          <h1 className="font-display text-3xl font-bold text-[#0B192C]">Pitch Trainer</h1>
          <p className="text-sm text-[#566270] mt-1">
            Sing a note and watch the needle: green means in tune. Choose a target note, start listening, and
            hold your note steady — like tuning an instrument, but the instrument is you.
          </p>
        </div>
        <PitchTrainerCore refA4={refA4} />
      </div>
    </div>
  );
}
